// Owner in P2: piece 14 "Ask screen" (docs/FILE-OWNERSHIP.md; docs/CONTRACTS.md sections 20.6 and 21).
// The feature's entry file (docs/CONTRACTS.md section 16): `/ask`, one lazy chunk.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { MessageSquareText } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/ask', component: lazyRouteComponent(() => import('./AskScreen.tsx')) })],
  nav: [{ to: '/ask', label: 'nav.ask', icon: MessageSquareText, group: 'work', key: 'a' }],
}
